// @ts-ignore
import {FormSelect} from '@/components/form/FormSelect.vue';
import {type Directive, type DirectiveBinding, type VNode} from 'vue';
import LocalStorage from '../library/localStorage';

const search: Directive = {
    mounted(el: HTMLElement, bindings: DirectiveBinding, vNode: VNode)
    {
        window.setTimeout(() =>
        {
            let defaultValues: Nullable<Array<string | number>> = null;
            let modelExpression                                 = bindings.value;

            const preInit = bindings.modifiers['pre-init'];

            if (!modelExpression)
            {
                console.error('v-search requires a model expression');
                return;
            }

            // form-select
            if (vNode?.el?.__vue__?.$options?.name !== 'FormSelect')
            {
                console.error('v-search is useless, if not bind on a form-select');
                return;
            }

            const instance: FormSelect = vNode.el.__vue__;

            if (!instance.multiple)
            {
                // nothing to do for single select ...
                return;
            }

            let node: any    = vNode.el;
            let storageScope = '';
            while (node && node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType === 1)
            {
                if (node.__vue__ && node.__vue__.currentScope)
                {
                    storageScope = node.__vue__.currentScope;
                }
                else if (node.__vue__ && node.__vue__.localStorageScope)
                {
                    storageScope = node.__vue__.localStorageScope;
                }

                node = node.parentNode as Node & ParentNode & Element;
            }

            let value: FormSelectValue              = instance.value;
            let metaStorage: Record<string, string> = {};
            let metaString: string                  = '';
            let resetValues                         = false;

            if (storageScope)
            {
                metaStorage = LocalStorage.get('meta.' + storageScope, {});
                metaString  = instance.metaString;
            }

            if (modelExpression && storageScope && metaStorage && metaString)
            {
                // reset values only if meta is already initialised and meta is different (otherwise preselect is broken)
                resetValues = !preInit && 'undefined' === typeof metaStorage[modelExpression] || metaStorage[modelExpression] !== metaString;

                if (metaStorage[modelExpression] !== metaString)
                {
                    metaStorage[modelExpression] = metaString;
                    LocalStorage.set('meta.' + storageScope, metaStorage);
                }
            }

            defaultValues = null;
            // if some values already selected ..
            //+ use pre-defined values
            if (
                !resetValues
                && instance.selectedModel
                && Array.isArray(instance.selectedModel)
                // wouldn't make much sense to pre-select an empty selection
                && instance.selectedModel!.length
            )
            {
                defaultValues = instance.selectedModel;
            }
            // otherwise, use all values in select options
            else if (resetValues || null === value || 'undefined' === typeof value)
            {
                defaultValues = [];
                for (let value of instance.parsedOptions)
                {
                    defaultValues.push(value.value);
                }
            }

            if (defaultValues)
            {
                instance.selectedModel = defaultValues;
            }

            defaultValues && (!Array.isArray(defaultValues) || defaultValues.length) && instance.$emit('update:modelValue', defaultValues);
        }, 0);
    },
};

export default search;